<template>
  <div class="hardone">
    <!-- <new></new> -->
    <parameter></parameter>
    <more></more>
    <iphandle></iphandle>
    <foot></foot> 
  </div>
</template>
<script>
import More from './more'
import Parameter from './parameter'
import Iphandle from './iphandle'
import Foot from './foot'

export default {
  name:'hardone',
  components:{ More,Parameter,Iphandle,Foot},
}
</script>

<style scoped>
  @media screen and (max-width:768px){
    .hardone{
      margin-top: 48px;
    }
  }
</style>


  


// WEBPACK FOOTER //
// src/components/hardProduct/hardone.vue